import { POST } from "../../index";
export const queryCompany = (param) => POST("/v1/CompanyController/queryCompany", param);
export const addCompany = (param) => POST("/v1/CompanyController/addCompany", param);
export const updateCompany = (param) => POST("/v1/CompanyController/updateCompany", param);
export const deleteCompany = (param) => POST("/v1/CompanyController/deleteCompany", param);
export const selectSingleCompany = (param) => POST("/v1/CompanyController/selectSingleCompany", param);
export const updateCompanyRole = (param) => POST("/v1/CompanyController/updateCompanyRole", param);
export const companyBindOrg = (param) => POST("/v1/CompanyController/companyBindOrg", param);